import React from 'react';
import { ResetPasswordContainer } from '../../containers';

const ResetPasswordPage = () => <ResetPasswordContainer />;

export default ResetPasswordPage;
